export default __webpack_public_path__ + "static/media/20_1_1.c4432499.png";